import { useEffect, useState } from 'react';
import { doc, getFirestore } from 'firebase/firestore';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { githubUrl } from './utils';

export const useCalendarData = () => {
  const [currentWeek, setCurrentWeek] = useState(0);
  const [weeks, setWeeks] = useState(null);
  const [allAssignments, setAllAssignments] = useState([]);

  const db = getFirestore();
  const courseId = 'humanities';
  const calendarRef = doc(db, `calendar/${courseId}`);
  const [calendarData] = useDocumentData(calendarRef);

  useEffect(() => {
    if (calendarData) {
      setWeeks(calendarData.weeks);
      setCurrentWeek(calendarData.currentWeek);
    }
  }, [calendarData]);

  useEffect(() => {
    const loadAssignmentsFromRepo = async () => {
      const response = await fetch(githubUrl);
      const assignmentsInRepo = await response.json();
      setAllAssignments(assignmentsInRepo);
    };
    loadAssignmentsFromRepo();
  }, []);

  return {
    db,
    courseId,
    calendarRef,
    weeks,
    setWeeks,
    currentWeek,
    setCurrentWeek,
    allAssignments,
    isLoading: !weeks,
  };
};
